"use client";

import type { ReactNode } from "react";
import { ProModalProvider } from "@/components/pro-modal-provider";
import type { PaywallPlanPresentation } from "@/lib/billing/paywallPresentation";

/**
 * Thin "use client" wrapper (MAP-123, D7) — the (editor) route group's own
 * copy of the (account) group's `ProModalMount.tsx` (D2/MAP-117), not a
 * shared import: route groups in this codebase keep their own top-level
 * layout wiring (see (editor)/layout.tsx's file header on why it doesn't
 * reuse (account)'s chrome either), and `(editor)/layout.tsx` is itself an
 * async server component (it awaits `getCurrentAccount` for the
 * anonSessionId/userId below), so it can't hold the modal's open/trigger
 * state directly — it passes `{children}` through this client boundary
 * instead. Every editor surface that renders the visibility listbox
 * (ShareModal, MAP-123) calls `useProUpsell()`, which throws outside this
 * provider — mounting it here at the layout root means every route under
 * `(editor)` (the "/" editor page and any others added later) has it.
 */
export function ProModalMount({
  children,
  anonSessionId,
  userId,
  plans,
  brandName,
}: {
  children: ReactNode;
  anonSessionId?: string;
  userId?: string;
  plans?: PaywallPlanPresentation[];
  brandName?: string;
}) {
  return (
    <ProModalProvider anonSessionId={anonSessionId} userId={userId} plans={plans} brandName={brandName}>
      {children}
    </ProModalProvider>
  );
}
